import nb from 'numbro';

/**
 * Переменная, представляющая строку локали, которая соответствует языковым и региональным настройкам.
 * Значение локали использует стандарт BCP 47 для обозначения языка и страны/региона.
 * В данном случае указана локаль для русского языка и региона России.
 *
 * Пример использования такого формата: 'ru-RU'.
 */
const locale = 'ru-RU';
nb.registerLanguage({
  languageTag: 'ru-RU',
  delimiters: {
    thousands: ' ',
    decimal: ',',
  },
  spaceSeparated: true,
  abbreviations: {
    thousand: 'тыс.',
    million: 'млн',
    billion: 'млрд',
    trillion: 'трлн',
  },
  ordinal: () => {
    // not ideal, but since in Russian it can taken on
    // different forms (masculine, feminine, neuter)
    // this is all we can do
    return '.';
  },
  currency: {
    symbol: 'руб.',
    position: 'postfix',
    code: 'RUB',
  },
  currencyFormat: {
    thousandSeparated: true,
    totalLength: 4,
    spaceSeparated: true,
    average: true,
  },
  formats: {
    fourDigits: {
      totalLength: 4,
      spaceSeparated: true,
      average: true,
    },
    fullWithTwoDecimals: {
      output: 'currency',
      mantissa: 2,
      spaceSeparated: true,
      thousandSeparated: true,
    },
    fullWithTwoDecimalsNoCurrency: {
      mantissa: 2,
      thousandSeparated: true,
    },
    fullWithNoDecimals: {
      output: 'currency',
      spaceSeparated: true,
      thousandSeparated: true,
      mantissa: 0,
    },
  },
});

nb.setLanguage(locale);

export { default as numbro } from 'numbro';
